import { motion } from "framer-motion";
import { EASE } from "../../lib/anim";
import { RadarDial } from "./Instrument";

const Marquee = () => {
  const items = ["Precisione", "Disciplina", "Affidabilità", "Visione"];
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="relative py-10 border-y border-white/10 overflow-hidden select-none">
      <div className="marquee">
        {row.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display text-6xl sm:text-7xl lg:text-8xl font-semibold tracking-tight text-transparent [-webkit-text-stroke:1px_rgba(255,255,255,0.22)] px-8">
              {w}
            </span>
            <span className="h-2 w-2 rounded-full bg-white/30" />
          </span>
        ))}
      </div>
    </div>
  );
};

export const Philosophy = () => {
  return (
    <section id="philosophy" className="relative bg-[#0c0d0f] py-28 sm:py-36" data-testid="philosophy-section">
      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 mb-16">
        <div className="flex items-center gap-4 mb-10">
          <span className="font-mono-x text-[11px] tracking-[0.3em] text-white/30">03</span>
          <span className="h-px w-10 bg-white/15" />
          <span className="eyebrow">Filosofia</span>
        </div>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1, ease: EASE }}
          className="font-display text-4xl sm:text-6xl lg:text-7xl font-semibold tracking-tight text-white max-w-4xl leading-[0.95]"
        >
          La nostra filosofia
        </motion.h2>
      </div>

      <Marquee />

      <div className="max-w-[1500px] mx-auto px-6 lg:px-12 mt-20 lg:mt-28">
        <div className="relative">
          <RadarDial className="hidden lg:block absolute left-[2%] top-1/2 -translate-y-1/2 w-[30%] max-w-[340px] pointer-events-none" />
        <div className="lg:pl-[38%]">
          <motion.p
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 1.1, ease: EASE }}
            className="font-display text-2xl sm:text-3xl lg:text-4xl leading-[1.35] tracking-tight text-white"
          >
            Ogni progetto ha un'identità propria. Ciò che li accomuna è il modo in cui vengono
            costruiti.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 1, ease: EASE, delay: 0.15 }}
            className="mt-12 space-y-6 max-w-xl text-base sm:text-lg text-white/45 leading-relaxed"
          >
            <p>
              Crediamo nella qualità prima della quantità, nella crescita prima della velocità e
              nella visione prima delle tendenze.
            </p>
            <p>
              MGB Aviation nasce con l'obiettivo di sviluppare realtà solide, indipendenti e capaci
              di generare valore nel tempo, mantenendo sempre l'aviazione come fonte di ispirazione.
            </p>
          </motion.div>
        </div>
        </div>
      </div>
    </section>
  );
};
